module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/KQKIYT/tc-custom/9781035803538.jpg?1716639652008",
      "alt": "This image is the cover for the book Spurious Conversations with Ghosts"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Spurious Conversations with Ghosts\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Ghosts A series of mild-mannered, malcontent, miscreants telling stories of mischief, malevolence, and murder. “I think that there are ghosts. I haven’t seen or heard anything. I’ve definitely felt something, but it’s not scary.” Robbie Williams “I don’t believe in ghosts.” Ryan Gosling")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Evelyne Morris\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Evelyne Morris was born in England towards the end of WW2, in 1944, but she comes from an international cultural background. Her grandparents were French/Italian and Maltese/Greek, and she was brought up in a college with foreign students from all over the world – Europe, the Far East, the Middle East, Africa and South America. She has a brother and sisters-in-law from Spain, France, and Japan, and she has daughters-in-law from Brazil and South Korea. She started writing after retirement, and this is her third novel.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0